// extracted by mini-css-extract-plugin
module.exports = {"main_container":"singleVideo_main_container__36qKk"};